import React from 'react';

/* ═══════════════════════════════════════════
   GRAND GATHER REGISTRY — COMPETITION PITCH DECK
   Combined brochure + app showcase for SAB Foundation
   Print-optimized, no watermarks
   ═══════════════════════════════════════════ */

const C = {
  coral: '#E3425C',
  gold: '#C9A84C',
  charcoal: '#0F0F11',
  dark: '#1A1A1E',
  cream: '#FAF8F5',
  sage: '#5C7A5A',
};

/* Phone mockup - prints with frame */
function Phone({ children, label }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
      <div style={{
        width: '260px', height: '520px',
        borderRadius: '36px',
        background: '#000',
        padding: '10px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
        position: 'relative', flexShrink: 0,
      }}>
        <div style={{
          position: 'absolute', top: '10px', left: '50%', transform: 'translateX(-50%)',
          width: '90px', height: '24px', background: '#000', borderRadius: '0 0 14px 14px', zIndex: 10,
        }}>
          <div style={{ position: 'absolute', top: '7px', left: '50%', transform: 'translateX(-50%)', width: '7px', height: '7px', borderRadius: '50%', background: '#1a1a2e' }} />
        </div>
        <div style={{
          width: '100%', height: '100%', borderRadius: '26px', overflow: 'hidden',
          background: '#fff', position: 'relative',
        }}>
          {children}
        </div>
        <div style={{
          position: 'absolute', bottom: '14px', left: '50%', transform: 'translateX(-50%)',
          width: '80px', height: '4px', borderRadius: '4px', background: 'rgba(255,255,255,0.15)',
        }} />
      </div>
      {label && (
        <div style={{ fontSize: '13px', fontWeight: 700, color: '#555', letterSpacing: '0.5px' }}>{label}</div>
      )}
    </div>
  );
}

/* ── SCREEN MOCKUPS ── */
function DashboardScreen() {
  return (
    <div style={{ height: '100%', background: '#FAFAFA', fontFamily: 'sans-serif', fontSize: '11px' }}>
      <div style={{ padding: '32px 14px 8px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '9px', color: '#999' }}>Welcome back</div>
            <div style={{ fontSize: '16px', fontWeight: 700, color: '#1a1a1a' }}>Thabo M.</div>
          </div>
          <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: `linear-gradient(135deg, ${C.coral}, ${C.gold})`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 700, fontSize: '12px' }}>T</div>
        </div>
      </div>
      <div style={{ padding: '0 14px 8px', display: 'flex', gap: '6px' }}>
        {[{ n: '3', l: 'Events', c: C.coral }, { n: '47', l: 'Guests', c: '#3B82F6' }, { n: '12', l: 'RSVPs', c: '#10B981' }].map((s, i) => (
          <div key={i} style={{ flex: 1, padding: '8px', borderRadius: '10px', background: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.04)', textAlign: 'center' }}>
            <div style={{ fontSize: '16px', fontWeight: 800, color: s.c }}>{s.n}</div>
            <div style={{ fontSize: '8px', color: '#999', fontWeight: 600 }}>{s.l}</div>
          </div>
        ))}
      </div>
      <div style={{ padding: '0 14px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
          <span style={{ fontSize: '12px', fontWeight: 700, color: '#333' }}>My Events</span>
          <span style={{ fontSize: '9px', color: C.coral, fontWeight: 600 }}>+ New Event</span>
        </div>
        <div style={{ borderRadius: '12px', overflow: 'hidden', marginBottom: '8px', background: 'white', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <div style={{ height: '70px', background: 'linear-gradient(135deg, #E8A0BF, #D4739D)', position: 'relative', padding: '10px' }}>
            <div style={{ position: 'absolute', top: '6px', right: '6px', background: 'rgba(255,255,255,0.9)', borderRadius: '20px', padding: '2px 8px', fontSize: '7px', fontWeight: 700, color: '#D4739D' }}>APR 15</div>
            <div style={{ position: 'absolute', bottom: '8px', left: '10px' }}>
              <div style={{ fontSize: '13px', fontWeight: 800, color: 'white' }}>Thabo & Lerato Wedding</div>
              <div style={{ fontSize: '8px', color: 'rgba(255,255,255,0.8)' }}>Sandton Convention Centre</div>
            </div>
          </div>
          <div style={{ padding: '8px 10px', display: 'flex', gap: '12px' }}>
            <div style={{ textAlign: 'center' }}><div style={{ fontSize: '11px', fontWeight: 800, color: '#333' }}>120</div><div style={{ fontSize: '7px', color: '#999' }}>Guests</div></div>
            <div style={{ textAlign: 'center' }}><div style={{ fontSize: '11px', fontWeight: 800, color: '#10B981' }}>85</div><div style={{ fontSize: '7px', color: '#999' }}>RSVPs</div></div>
            <div style={{ textAlign: 'center' }}><div style={{ fontSize: '11px', fontWeight: 800, color: C.gold }}>R24k</div><div style={{ fontSize: '7px', color: '#999' }}>Gifts</div></div>
          </div>
        </div>
        <div style={{ borderRadius: '12px', overflow: 'hidden', marginBottom: '8px', background: 'white', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <div style={{ height: '70px', background: 'linear-gradient(135deg, #D4A574, #8B6914)', position: 'relative', padding: '10px' }}>
            <div style={{ position: 'absolute', top: '6px', right: '6px', background: 'rgba(255,255,255,0.9)', borderRadius: '20px', padding: '2px 8px', fontSize: '7px', fontWeight: 700, color: '#8B6914' }}>MAY 22</div>
            <div style={{ position: 'absolute', bottom: '8px', left: '10px' }}>
              <div style={{ fontSize: '13px', fontWeight: 800, color: 'white' }}>Lobola Ceremony</div>
              <div style={{ fontSize: '8px', color: 'rgba(255,255,255,0.8)' }}>Pretoria East</div>
            </div>
          </div>
        </div>
        <div style={{ borderRadius: '12px', overflow: 'hidden', background: 'white', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <div style={{ height: '50px', background: 'linear-gradient(135deg, #FFB347, #FF6B6B)', position: 'relative', padding: '10px' }}>
            <div style={{ position: 'absolute', bottom: '8px', left: '10px' }}>
              <div style={{ fontSize: '12px', fontWeight: 800, color: 'white' }}>Nomsa's 30th Birthday</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function GigiScreen() {
  return (
    <div style={{ height: '100%', background: '#f8f8fa', fontFamily: 'sans-serif', fontSize: '11px', display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: '32px 12px 10px', background: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: `linear-gradient(135deg, ${C.coral}, #FF8A9E)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px' }}>🤖</div>
          <div>
            <div style={{ fontSize: '13px', fontWeight: 700 }}>GiGi AI</div>
            <div style={{ fontSize: '8px', color: '#10B981', fontWeight: 600 }}>Online • 7 SA Languages</div>
          </div>
        </div>
      </div>
      <div style={{ flex: 1, padding: '10px', overflow: 'hidden' }}>
        <div style={{ display: 'flex', gap: '6px', marginBottom: '10px' }}>
          <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: `linear-gradient(135deg, ${C.coral}, #FF8A9E)`, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '9px' }}>🤖</div>
          <div style={{ background: 'white', borderRadius: '12px 12px 12px 4px', padding: '8px 10px', maxWidth: '80%', boxShadow: '0 1px 3px rgba(0,0,0,0.03)' }}>
            <div style={{ fontSize: '10px', color: '#333', lineHeight: 1.5 }}>
              Sawubona! 👋 I'm GiGi. I can help in <strong>English, isiZulu, Setswana, Sesotho, Sepitori, isiXhosa</strong> & <strong>Afrikaans</strong>.
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
          <div style={{ background: C.coral, borderRadius: '12px 12px 4px 12px', padding: '8px 10px', maxWidth: '75%' }}>
            <div style={{ fontSize: '10px', color: 'white', lineHeight: 1.5 }}>Ngicela ungenzele i-checklist ye-wedding yami</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '6px', marginBottom: '10px' }}>
          <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: `linear-gradient(135deg, ${C.coral}, #FF8A9E)`, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '9px' }}>🤖</div>
          <div style={{ background: 'white', borderRadius: '12px 12px 12px 4px', padding: '8px 10px', maxWidth: '80%', boxShadow: '0 1px 3px rgba(0,0,0,0.03)' }}>
            <div style={{ fontSize: '10px', color: '#333', lineHeight: 1.6 }}>
              Yebo! Nansi i-checklist: ✨<br/>
              ✅ Buka indawo yomcimbi<br/>
              ✅ Khetha umpheki wokudla<br/>
              ✅ Thumela izimemo<br/>
              ✅ Buka umculi/DJ<br/>
              ✅ Khetha ingubo yomshado<br/>
              <span style={{ color: C.coral, fontWeight: 600 }}>📋 Apply to checklist?</span>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
          {['📋 Checklist', '💰 Budget', '📝 Description', '💝 Thank you'].map((a, i) => (
            <div key={i} style={{ padding: '5px 10px', borderRadius: '16px', fontSize: '9px', background: 'white', border: `1px solid ${C.coral}25`, color: C.coral, fontWeight: 600 }}>{a}</div>
          ))}
        </div>
      </div>
    </div>
  );
}

function InvitationScreen() {
  return (
    <div style={{ height: '100%', background: '#1a1020', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div style={{
        width: '100%', background: 'linear-gradient(180deg, #2a1f3a, #1a1020)',
        borderRadius: '16px', border: `1px solid ${C.gold}30`, padding: '24px 16px', textAlign: 'center', position: 'relative',
      }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '50px', height: '50px', borderTop: `2px solid ${C.gold}40`, borderLeft: `2px solid ${C.gold}40`, borderRadius: '16px 0 0 0' }} />
        <div style={{ position: 'absolute', top: 0, right: 0, width: '50px', height: '50px', borderTop: `2px solid ${C.gold}40`, borderRight: `2px solid ${C.gold}40`, borderRadius: '0 16px 0 0' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, width: '50px', height: '50px', borderBottom: `2px solid ${C.gold}40`, borderLeft: `2px solid ${C.gold}40`, borderRadius: '0 0 0 16px' }} />
        <div style={{ position: 'absolute', bottom: 0, right: 0, width: '50px', height: '50px', borderBottom: `2px solid ${C.gold}40`, borderRight: `2px solid ${C.gold}40`, borderRadius: '0 0 16px 0' }} />
        <img src="/gift-icon-v2.png" alt="GGR" style={{ height: '28px', marginBottom: '10px', opacity: 0.7 }} />
        <div style={{ fontSize: '9px', color: `${C.gold}90`, letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '12px' }}>You are invited</div>
        <div style={{ fontSize: '8px', color: 'rgba(255,255,255,0.4)', marginBottom: '6px' }}>to the wedding of</div>
        <div style={{ fontFamily: 'Georgia, serif', fontSize: '22px', fontWeight: 700, color: C.gold, lineHeight: 1.2 }}>Thabo</div>
        <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.3)', fontStyle: 'italic', margin: '3px 0' }}>&</div>
        <div style={{ fontFamily: 'Georgia, serif', fontSize: '22px', fontWeight: 700, color: C.gold, lineHeight: 1.2, marginBottom: '14px' }}>Lerato</div>
        <div style={{ width: '30px', height: '1px', background: `${C.gold}40`, margin: '0 auto 12px' }} />
        <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.6)', marginBottom: '3px' }}>Saturday, April 15th 2026</div>
        <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.6)', marginBottom: '3px' }}>at 2:00 PM</div>
        <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.4)', marginBottom: '14px' }}>Sandton Convention Centre</div>
        <div style={{ display: 'inline-block', padding: '8px 20px', borderRadius: '20px', background: `linear-gradient(135deg, ${C.gold}, #E8D59A)`, color: '#1a1020', fontWeight: 700, fontSize: '10px', letterSpacing: '1px' }}>RSVP NOW</div>
      </div>
    </div>
  );
}

function VendorScreen() {
  return (
    <div style={{ height: '100%', background: '#FAFAFA', fontFamily: 'sans-serif', fontSize: '11px' }}>
      <div style={{ padding: '32px 12px 10px', background: 'white' }}>
        <div style={{ fontSize: '16px', fontWeight: 700, color: '#1a1a1a', marginBottom: '8px' }}>Vendor Marketplace</div>
        <div style={{ display: 'flex', gap: '5px' }}>
          {['All', 'Catering', 'Photo', 'DJ', 'Decor'].map((cat, i) => (
            <div key={i} style={{ padding: '5px 12px', borderRadius: '16px', fontSize: '9px', fontWeight: 600, background: i === 0 ? C.coral : '#f0f0f0', color: i === 0 ? 'white' : '#666' }}>{cat}</div>
          ))}
        </div>
      </div>
      <div style={{ padding: '8px 12px' }}>
        {[
          { name: 'Mama Zandi Catering', cat: 'Catering • Soweto', rating: '4.9', color: '#F97316', avatar: 'MZ', verified: true },
          { name: 'Lebo Photography', cat: 'Photography • Sandton', rating: '4.8', color: '#8B5CF6', avatar: 'LP', verified: true },
          { name: 'DJ Mkhize', cat: 'DJ & Sound • Durban', rating: '4.7', color: '#3B82F6', avatar: 'DM', verified: false },
          { name: 'Blossom Decor Studio', cat: 'Decor • Pretoria', rating: '4.9', color: '#EC4899', avatar: 'BD', verified: true },
          { name: 'Ubuntu Venue Hire', cat: 'Venue • Centurion', rating: '4.6', color: '#10B981', avatar: 'UV', verified: true },
        ].map((v, i) => (
          <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '10px', marginBottom: '6px', boxShadow: '0 1px 4px rgba(0,0,0,0.04)', display: 'flex', gap: '8px' }}>
            <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: `${v.color}15`, color: v.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: '12px', flexShrink: 0 }}>{v.avatar}</div>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                <span style={{ fontSize: '11px', fontWeight: 700 }}>{v.name}</span>
                {v.verified && <span style={{ fontSize: '9px', color: '#3B82F6' }}>✓</span>}
              </div>
              <div style={{ fontSize: '8px', color: '#999', marginTop: '1px' }}>{v.cat}</div>
              <div style={{ fontSize: '9px', color: '#F59E0B', marginTop: '2px' }}>★ {v.rating}</div>
            </div>
            <div style={{ alignSelf: 'center', padding: '4px 8px', borderRadius: '6px', fontSize: '8px', background: `${C.coral}12`, color: C.coral, fontWeight: 700 }}>Quote</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function GiftScreen() {
  return (
    <div style={{ height: '100%', background: '#fff', fontFamily: 'sans-serif', fontSize: '11px' }}>
      <div style={{ padding: '32px 12px 10px', background: `linear-gradient(135deg, ${C.gold}, #E8D59A)` }}>
        <div style={{ fontSize: '14px', fontWeight: 700, color: '#1a1020', marginBottom: '6px' }}>Gift Registry</div>
        <div style={{ display: 'flex', gap: '6px' }}>
          <div style={{ flex: 1, padding: '8px', borderRadius: '8px', background: 'rgba(255,255,255,0.3)', textAlign: 'center' }}>
            <div style={{ fontSize: '14px', fontWeight: 800, color: '#1a1020' }}>R 24,500</div>
            <div style={{ fontSize: '7px', color: '#1a102099', fontWeight: 600 }}>Received</div>
          </div>
          <div style={{ flex: 1, padding: '8px', borderRadius: '8px', background: 'rgba(255,255,255,0.3)', textAlign: 'center' }}>
            <div style={{ fontSize: '14px', fontWeight: 800, color: '#1a1020' }}>8/15</div>
            <div style={{ fontSize: '7px', color: '#1a102099', fontWeight: 600 }}>Claimed</div>
          </div>
        </div>
      </div>
      <div style={{ padding: '8px 12px' }}>
        {[
          { name: 'KitchenAid Mixer', price: 'R 5,999', claimed: true, icon: '🍳' },
          { name: 'Bedding Set (King)', price: 'R 2,499', claimed: true, icon: '🛏️' },
          { name: 'Cash: Honeymoon Fund', price: 'R 8,000', claimed: true, icon: '✈️' },
          { name: 'Dinner Set (12pc)', price: 'R 3,200', claimed: false, icon: '🍽️' },
          { name: 'Smart TV 55"', price: 'R 8,999', claimed: false, icon: '📺' },
          { name: 'Microwave', price: 'R 2,199', claimed: true, icon: '🔌' },
        ].map((g, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 0', borderBottom: '1px solid #f5f5f5' }}>
            <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: g.claimed ? '#10B98110' : '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px' }}>{g.icon}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '11px', fontWeight: 600 }}>{g.name}</div>
              <div style={{ fontSize: '8px', color: '#999' }}>{g.price}</div>
            </div>
            <div style={{ padding: '2px 6px', borderRadius: '10px', fontSize: '8px', fontWeight: 700, background: g.claimed ? '#10B98115' : '#F59E0B15', color: g.claimed ? '#10B981' : '#F59E0B' }}>{g.claimed ? 'Claimed' : 'Available'}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function TicketScreen() {
  return (
    <div style={{ height: '100%', background: 'linear-gradient(180deg, #E8A0BF, #D4739D)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div style={{ width: '100%', maxWidth: '220px', background: 'white', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 16px 40px rgba(0,0,0,0.15)', position: 'relative' }}>
        <div style={{ padding: '16px 14px', textAlign: 'center' }}>
          <div style={{ fontSize: '8px', color: '#999', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '6px' }}>Event Ticket</div>
          <div style={{ fontSize: '15px', fontWeight: 800, color: '#1a1a1a', marginBottom: '3px' }}>Thabo & Lerato</div>
          <div style={{ fontSize: '10px', color: '#D4739D', fontWeight: 600 }}>Wedding Celebration</div>
        </div>
        <div style={{ position: 'relative', height: '1px', background: 'repeating-linear-gradient(90deg, #ddd 0px, #ddd 4px, transparent 4px, transparent 8px)' }}>
          <div style={{ position: 'absolute', left: '-8px', top: '-8px', width: '16px', height: '16px', borderRadius: '50%', background: 'linear-gradient(180deg, #E8A0BF, #D4739D)' }} />
          <div style={{ position: 'absolute', right: '-8px', top: '-8px', width: '16px', height: '16px', borderRadius: '50%', background: 'linear-gradient(180deg, #E8A0BF, #D4739D)' }} />
        </div>
        <div style={{ padding: '12px 14px', textAlign: 'center' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '10px', textAlign: 'left' }}>
            {[{ l: 'Date', v: 'Apr 15, 2026' }, { l: 'Time', v: '14:00' }, { l: 'Venue', v: 'Sandton CC' }, { l: 'Guest', v: 'Sipho Ndlovu' }].map((d, i) => (
              <div key={i}>
                <div style={{ fontSize: '7px', color: '#bbb', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase' }}>{d.l}</div>
                <div style={{ fontSize: '10px', fontWeight: 700, color: '#333' }}>{d.v}</div>
              </div>
            ))}
          </div>
          <div style={{ width: '80px', height: '80px', margin: '0 auto 6px', background: '#1a1a1a', borderRadius: '6px', padding: '6px', display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gridTemplateRows: 'repeat(7, 1fr)', gap: '2px' }}>
            {Array.from({ length: 49 }).map((_, i) => (
              <div key={i} style={{ background: [0,1,2,4,5,6,7,13,14,20,21,27,28,34,35,41,42,43,44,46,47,48,3,8,9,11,12,15,19,22,26,29,33,36,40,45,10,16,18,23,25,30,32,37,39].includes(i) ? 'white' : 'transparent', borderRadius: '1px' }} />
            ))}
          </div>
          <div style={{ fontSize: '9px', fontWeight: 700, color: '#D4739D', fontFamily: 'monospace' }}>TKT-WED-2026-0042</div>
        </div>
      </div>
    </div>
  );
}

function GalleryScreen() {
  return (
    <div style={{ height: '100%', background: '#fff', fontFamily: 'sans-serif', fontSize: '11px' }}>
      <div style={{ padding: '32px 12px 10px', background: 'white', borderBottom: '1px solid #f0f0f0' }}>
        <div style={{ fontSize: '14px', fontWeight: 700, marginBottom: '6px' }}>Gallery</div>
        <div style={{ display: 'flex', gap: '5px' }}>
          {['Grid', 'Masonry', 'Carousel'].map((l, i) => (
            <div key={i} style={{ padding: '4px 10px', borderRadius: '14px', fontSize: '9px', fontWeight: 600, background: i === 0 ? C.coral : '#f0f0f0', color: i === 0 ? 'white' : '#888' }}>{l}</div>
          ))}
        </div>
      </div>
      <div style={{ padding: '8px' }}>
        <div style={{ fontSize: '9px', color: '#999', padding: '0 4px 6px' }}>24 photos • 3 videos</div>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '3px', marginBottom: '3px' }}>
          <div style={{ height: '110px', borderRadius: '8px', background: 'linear-gradient(135deg, #FFE4EC, #D4739D)', position: 'relative' }}>
            <div style={{ position: 'absolute', bottom: '6px', left: '6px', padding: '2px 6px', borderRadius: '10px', background: 'rgba(0,0,0,0.5)', fontSize: '7px', color: 'white' }}>❤️ 45</div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
            <div style={{ flex: 1, borderRadius: '8px', background: 'linear-gradient(135deg, #E8D5B7, #C9A84C)' }} />
            <div style={{ flex: 1, borderRadius: '8px', background: 'linear-gradient(135deg, #C8E6C9, #81C784)' }} />
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '3px', marginBottom: '3px' }}>
          <div style={{ height: '75px', borderRadius: '8px', background: 'linear-gradient(135deg, #BBDEFB, #64B5F6)', position: 'relative' }}>
            <div style={{ position: 'absolute', top: '4px', right: '4px', padding: '2px 5px', borderRadius: '6px', background: 'rgba(0,0,0,0.4)', fontSize: '6px', color: 'white' }}>🎥 0:42</div>
          </div>
          <div style={{ height: '75px', borderRadius: '8px', background: 'linear-gradient(135deg, #F3E5F5, #CE93D8)' }} />
          <div style={{ height: '75px', borderRadius: '8px', background: 'linear-gradient(135deg, #FFF3E0, #FFB74D)' }} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '3px', marginBottom: '3px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
            <div style={{ flex: 1, borderRadius: '8px', background: 'linear-gradient(135deg, #FFCDD2, #EF9A9A)' }} />
            <div style={{ flex: 1, borderRadius: '8px', background: 'linear-gradient(135deg, #D7CCC8, #A1887F)' }} />
          </div>
          <div style={{ height: '100px', borderRadius: '8px', background: 'linear-gradient(135deg, #1a1020, #D4739D)', position: 'relative' }}>
            <div style={{ position: 'absolute', top: '4px', right: '4px', padding: '2px 5px', borderRadius: '6px', background: 'rgba(0,0,0,0.4)', fontSize: '6px', color: 'white' }}>🎥 2:15</div>
            <div style={{ position: 'absolute', bottom: '6px', left: '6px', padding: '2px 6px', borderRadius: '10px', background: 'rgba(0,0,0,0.5)', fontSize: '7px', color: 'white' }}>❤️ 67</div>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '3px' }}>
          <div style={{ height: '75px', borderRadius: '8px', background: 'linear-gradient(135deg, #B2DFDB, #4DB6AC)' }} />
          <div style={{ height: '75px', borderRadius: '8px', background: 'linear-gradient(135deg, #FFE082, #FFC107)' }} />
          <div style={{ height: '75px', borderRadius: '8px', background: 'linear-gradient(135deg, #F8BBD0, #EC407A)' }} />
        </div>
      </div>
    </div>
  );
}

/* App Store Badge SVG */
function AppStoreBadge({ type }) {
  const isApple = type === 'apple';
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: '8px',
      padding: '10px 20px', borderRadius: '10px',
      background: '#000', color: 'white',
      border: '1px solid rgba(255,255,255,0.2)',
    }}>
      <div style={{ fontSize: '24px' }}>{isApple ? '🍎' : '▶️'}</div>
      <div>
        <div style={{ fontSize: '8px', color: 'rgba(255,255,255,0.7)', lineHeight: 1 }}>{isApple ? 'Download on the' : 'GET IT ON'}</div>
        <div style={{ fontSize: '14px', fontWeight: 700, lineHeight: 1.2 }}>{isApple ? 'App Store' : 'Google Play'}</div>
      </div>
    </div>
  );
}


/* ═══════════════════════════════════════════
   MAIN PITCH DECK
   ═══════════════════════════════════════════ */
export default function PitchDeck() {
  return (
    <div style={{ background: 'white', minHeight: '100vh', fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&display=swap');
        .pitch-page * { box-sizing: border-box; margin: 0; padding: 0; }
        .pitch-slide { min-height: 100vh; position: relative; overflow: hidden; }
        .phones-grid { display: flex; gap: 28px; flex-wrap: wrap; justify-content: center; align-items: flex-start; }
        @media print {
          * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; color-adjust: exact !important; }
          .pitch-slide { page-break-after: always; min-height: 100vh; }
          .no-print { display: none !important; }
          body { margin: 0; padding: 0; }
        }
        @page { size: A4 portrait; margin: 0; }
      `}</style>

      <div className="pitch-page">

        {/* Print button */}
        <div className="no-print" style={{ position: 'fixed', top: '16px', right: '16px', zIndex: 100 }}>
          <button onClick={() => window.print()} style={{
            padding: '10px 20px', borderRadius: '8px', border: 'none',
            background: C.coral, color: 'white', fontSize: '13px', fontWeight: 700, cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(227,66,92,0.3)',
          }}>Save as PDF</button>
        </div>

        {/* ═══════ SLIDE 1: COVER ═══════ */}
        <section className="pitch-slide" style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          padding: '60px 32px', textAlign: 'center',
          background: `radial-gradient(ellipse at 30% 20%, rgba(227,66,92,0.06) 0%, transparent 50%), radial-gradient(ellipse at 70% 80%, rgba(201,168,76,0.04) 0%, transparent 50%), white`,
        }}>
          <img src="/gift-icon-v2.png" alt="GGR" style={{ height: '100px', marginBottom: '24px', filter: 'drop-shadow(0 8px 24px rgba(227,66,92,0.2))' }} />

          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '8px',
            padding: '8px 20px', borderRadius: '50px',
            background: `${C.coral}10`, border: `1px solid ${C.coral}20`, marginBottom: '28px',
          }}>
            <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: C.coral }} />
            <span style={{ fontSize: '11px', color: C.coral, fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase' }}>SAB Foundation Social Innovation Awards 2026</span>
          </div>

          <h1 style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: '56px', fontWeight: 700, lineHeight: 1.1,
            color: C.charcoal, marginBottom: '16px',
          }}>
            Grand Gather<br />
            <span style={{ color: C.coral }}>Registry</span>
          </h1>

          <p style={{ fontSize: '18px', color: '#777', maxWidth: '550px', lineHeight: 1.6, marginBottom: '40px' }}>
            South Africa's first AI-powered event planning and vendor marketplace platform — built for African celebrations, in African languages.
          </p>

          <div style={{ display: 'flex', gap: '40px', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '40px' }}>
            {[
              { n: '20+', l: 'Smart Features' },
              { n: '12+', l: 'SA Event Types' },
              { n: '7', l: 'SA Languages' },
              { n: 'Top 3', l: 'SAFT Awards 2025' },
            ].map((s, i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                <div style={{ fontFamily: "'Playfair Display', serif", fontSize: '36px', fontWeight: 700, color: C.coral }}>{s.n}</div>
                <div style={{ fontSize: '11px', color: '#999', letterSpacing: '1px', textTransform: 'uppercase', marginTop: '4px' }}>{s.l}</div>
              </div>
            ))}
          </div>

          <div style={{ fontSize: '12px', color: '#bbb', letterSpacing: '3px', textTransform: 'uppercase' }}>
            Plan. Register. Celebrate.
          </div>

          <div style={{ position: 'absolute', bottom: '24px', fontSize: '11px', color: '#ccc' }}>
            grandgatherregistry.co.za — Ga-Rankuwa, South Africa
          </div>
        </section>

        {/* ═══════ SLIDE 2: THE PROBLEM ═══════ */}
        <section className="pitch-slide" style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '60px 32px',
          background: '#FAFAFA',
        }}>
          <div style={{ maxWidth: '900px', width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
              <div style={{ width: '40px', height: '2px', background: C.coral }} />
              <span style={{ fontSize: '11px', fontWeight: 700, color: C.coral, letterSpacing: '3px', textTransform: 'uppercase' }}>The Problem</span>
            </div>

            <h2 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '40px', fontWeight: 700, color: C.charcoal, lineHeight: 1.2, marginBottom: '40px', maxWidth: '650px',
            }}>
              Event planning in South Africa is <span style={{ color: C.coral, fontStyle: 'italic' }}>fragmented, informal</span> and excludes millions.
            </h2>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
              {[
                { emoji: '📱', title: 'WhatsApp Chaos', desc: 'Guest lists scattered across groups. RSVPs lost in chat. No tracking, no coordination.', stat: '80% of SA event planning happens on WhatsApp' },
                { emoji: '💸', title: 'Vendor Vulnerability', desc: 'Township vendors lack digital visibility. Income is inconsistent. Exposure to fraud and non-payment.', stat: '45% youth unemployment drives informal entrepreneurship' },
                { emoji: '🎁', title: 'Gift Duplication', desc: 'No central registry means duplicate gifts, awkward cash requests and zero tracking.', stat: 'Zero culturally-relevant gift registry platforms in SA' },
                { emoji: '🌍', title: 'Digital Exclusion', desc: 'Existing tools are English-only, Western-focused. No support for Lobola, Umembeso, or SA funeral customs.', stat: '7 out of 11 official languages underserved digitally' },
              ].map((item, i) => (
                <div key={i} style={{
                  padding: '24px', borderRadius: '14px',
                  background: 'white', border: '1px solid #f0f0f0',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.02)',
                }}>
                  <div style={{ fontSize: '28px', marginBottom: '12px' }}>{item.emoji}</div>
                  <h3 style={{ fontSize: '16px', fontWeight: 700, color: C.charcoal, marginBottom: '6px' }}>{item.title}</h3>
                  <p style={{ fontSize: '13px', lineHeight: 1.6, color: '#777', marginBottom: '10px' }}>{item.desc}</p>
                  <div style={{ fontSize: '11px', color: C.coral, fontWeight: 600, fontStyle: 'italic' }}>{item.stat}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ═══════ SLIDE 3: APP SCREENS — DASHBOARD + GIGI ═══════ */}
        <section className="pitch-slide" style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          padding: '60px 32px',
          background: `linear-gradient(180deg, ${C.charcoal} 0%, ${C.dark} 100%)`,
        }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <span style={{ fontSize: '11px', fontWeight: 700, color: C.gold, letterSpacing: '3px', textTransform: 'uppercase' }}>The Platform</span>
            <h2 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '40px', fontWeight: 700, color: 'white', lineHeight: 1.2, marginTop: '12px',
            }}>
              Smart Dashboard. <span style={{ color: C.coral }}>AI in 7 Languages.</span>
            </h2>
            <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.4)', maxWidth: '450px', margin: '10px auto 0' }}>
              Manage events, track RSVPs and get AI-powered planning assistance from GiGi — in isiZulu, Setswana, Sesotho, Sepitori, isiXhosa, Afrikaans and English.
            </p>
          </div>

          <div className="phones-grid">
            <Phone label="Event Dashboard"><DashboardScreen /></Phone>
            <Phone label="GiGi AI Assistant"><GigiScreen /></Phone>
          </div>
        </section>

        {/* ═══════ SLIDE 4: INVITATIONS + VENDORS ═══════ */}
        <section className="pitch-slide" style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          padding: '60px 32px',
          background: 'white',
        }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <span style={{ fontSize: '11px', fontWeight: 700, color: C.coral, letterSpacing: '3px', textTransform: 'uppercase' }}>Connect & Celebrate</span>
            <h2 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '40px', fontWeight: 700, color: C.charcoal, lineHeight: 1.2, marginTop: '12px',
            }}>
              Digital Invitations. <span style={{ color: C.gold }}>Verified Vendors.</span>
            </h2>
            <p style={{ fontSize: '14px', color: '#999', maxWidth: '500px', margin: '10px auto 0' }}>
              Beautiful themed invitations shareable via WhatsApp, and a verified marketplace connecting hosts with township and rural vendors.
            </p>
          </div>

          <div className="phones-grid">
            <Phone label="Digital Invitation"><InvitationScreen /></Phone>
            <Phone label="Vendor Marketplace"><VendorScreen /></Phone>
          </div>
        </section>

        {/* ═══════ SLIDE 5: GIFTS + TICKETS + GALLERY ═══════ */}
        <section className="pitch-slide" style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          padding: '60px 32px',
          background: `linear-gradient(180deg, ${C.charcoal} 0%, ${C.dark} 100%)`,
        }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <span style={{ fontSize: '11px', fontWeight: 700, color: '#10B981', letterSpacing: '3px', textTransform: 'uppercase' }}>Complete Ecosystem</span>
            <h2 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '40px', fontWeight: 700, color: 'white', lineHeight: 1.2, marginTop: '12px',
            }}>
              Gifts. Tickets. <span style={{ color: C.coral }}>Gallery.</span>
            </h2>
            <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.4)', maxWidth: '500px', margin: '10px auto 0' }}>
              Gift registry with tracking, QR-coded event tickets with scan-at-door verification, and a shared photo gallery.
            </p>
          </div>

          <div className="phones-grid">
            <Phone label="Gift Registry"><GiftScreen /></Phone>
            <Phone label="QR Event Ticket"><TicketScreen /></Phone>
            <Phone label="Photo Gallery"><GalleryScreen /></Phone>
          </div>
        </section>

        {/* ═══════ SLIDE 6: CULTURAL RELEVANCE ═══════ */}
        <section className="pitch-slide" style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '60px 32px',
          background: '#FAFAFA',
        }}>
          <div style={{ maxWidth: '900px', width: '100%' }}>
            <div style={{ textAlign: 'center', marginBottom: '40px' }}>
              <span style={{ fontSize: '11px', fontWeight: 700, color: C.sage, letterSpacing: '3px', textTransform: 'uppercase' }}>Built for Africa</span>
              <h2 style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: '40px', fontWeight: 700, color: C.charcoal, lineHeight: 1.2, marginTop: '12px',
              }}>
                Every celebration, <span style={{ color: C.coral, fontStyle: 'italic' }}>every culture.</span>
              </h2>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '32px' }}>
              {[
                { type: 'Wedding', emoji: '💍', color: '#E8A0BF' },
                { type: 'Lobola', emoji: '🤝', color: '#D4A574' },
                { type: 'Umembeso', emoji: '🎀', color: '#8FBC8F' },
                { type: 'Birthday', emoji: '🎂', color: '#FFB347' },
                { type: 'Funeral', emoji: '🕊️', color: '#9E9E9E' },
                { type: 'Graduation', emoji: '🎓', color: '#4FC3F7' },
                { type: 'Gender Reveal', emoji: '🎉', color: '#DDA0DD' },
                { type: 'Matric Dance', emoji: '💃', color: '#C084FC' },
                { type: 'Corporate', emoji: '🏢', color: '#38BDF8' },
                { type: 'Memorial', emoji: '🌹', color: '#A0A0A0' },
                { type: 'Baby Shower', emoji: '👶', color: '#FFB6C1' },
                { type: 'Engagement', emoji: '💐', color: '#FF6B6B' },
              ].map((e, i) => (
                <div key={i} style={{
                  padding: '16px 12px', borderRadius: '12px', textAlign: 'center',
                  background: 'white', border: '1px solid #f0f0f0',
                }}>
                  <div style={{ fontSize: '24px', marginBottom: '6px' }}>{e.emoji}</div>
                  <div style={{ fontSize: '11px', fontWeight: 700, color: e.color }}>{e.type}</div>
                </div>
              ))}
            </div>

            {/* GiGi languages bar */}
            <div style={{
              padding: '20px 24px', borderRadius: '14px',
              background: C.charcoal, display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap',
            }}>
              <img src="/gigi-mascot.png" alt="GiGi" style={{ width: '48px', height: '48px', borderRadius: '50%', border: `2px solid ${C.coral}33`, objectFit: 'contain' }} />
              <div style={{ flex: 1, minWidth: '200px' }}>
                <h3 style={{ fontSize: '16px', fontWeight: 700, color: 'white', marginBottom: '4px' }}>GiGi — AI Event Planner</h3>
                <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', lineHeight: 1.5 }}>
                  Speaks <strong style={{ color: C.gold }}>English, isiZulu, Setswana, Sesotho, Sepitori, isiXhosa & Afrikaans</strong>. Generates checklists, budgets, timelines, descriptions and personalised thank-you messages for every event type.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ═══════ SLIDE 7: REVENUE + TARGET GROUPS ═══════ */}
        <section className="pitch-slide" style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '60px 32px',
          background: `linear-gradient(135deg, ${C.charcoal} 0%, #1a1020 100%)`,
        }}>
          <div style={{ maxWidth: '900px', width: '100%' }}>
            <div style={{ textAlign: 'center', marginBottom: '40px' }}>
              <span style={{ fontSize: '11px', fontWeight: 700, color: C.gold, letterSpacing: '3px', textTransform: 'uppercase' }}>Sustainable Business Model</span>
              <h2 style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: '40px', fontWeight: 700, color: 'white', lineHeight: 1.2, marginTop: '12px',
              }}>
                Four Revenue <span style={{ color: C.gold }}>Streams</span>
              </h2>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '40px' }}>
              {[
                { num: '01', title: 'Vendor Subscriptions & Commission', desc: 'Free – R499/mo. First R5,000 commission-free. Then 8%/3%/0% by tier. Free tier available for new vendors.', accent: C.coral },
                { num: '02', title: 'Gift Code Affiliate', desc: '5% commission on gift purchases through retail partner code system (GGR-XX-XXXXX format).', accent: C.gold },
                { num: '03', title: 'Premium Features', desc: 'R99-R199 per event for advanced analytics, AI recommendations and premium invitation templates.', accent: '#3B82F6' },
                { num: '04', title: 'Sponsored Advertising', desc: 'Featured vendor listings and banner placements for event-related businesses. Monthly subscription model.', accent: '#8B5CF6' },
              ].map((r, i) => (
                <div key={i} style={{
                  padding: '24px 20px', borderRadius: '14px',
                  background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
                }}>
                  <div style={{ fontSize: '12px', fontWeight: 800, color: r.accent, marginBottom: '8px', letterSpacing: '1px' }}>{r.num}</div>
                  <h3 style={{ fontSize: '15px', fontWeight: 700, color: 'white', marginBottom: '6px' }}>{r.title}</h3>
                  <p style={{ fontSize: '12px', lineHeight: 1.6, color: 'rgba(255,255,255,0.4)' }}>{r.desc}</p>
                </div>
              ))}
            </div>

            {/* Target groups */}
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
              {[
                { icon: '👩', label: 'Women Entrepreneurs', desc: 'Catering, decor, baking vendors gain digital visibility' },
                { icon: '👨‍🎓', label: 'Youth', desc: 'Digital jobs + vendor marketplace access' },
                { icon: '🏘️', label: 'Rural Communities', desc: '7-language AI breaks digital barriers' },
                { icon: '♿', label: 'Persons with Disabilities', desc: 'Voice-enabled AI assistant for accessibility' },
              ].map((t, i) => (
                <div key={i} style={{
                  flex: '1 1 180px', padding: '16px', borderRadius: '12px',
                  background: `${C.coral}10`, border: `1px solid ${C.coral}15`,
                  textAlign: 'center',
                }}>
                  <div style={{ fontSize: '24px', marginBottom: '6px' }}>{t.icon}</div>
                  <div style={{ fontSize: '12px', fontWeight: 700, color: 'white', marginBottom: '4px' }}>{t.label}</div>
                  <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.4)', lineHeight: 1.4 }}>{t.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ═══════ SLIDE 8: READY TO SCALE ═══════ */}
        <section className="pitch-slide" style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          padding: '60px 32px', textAlign: 'center',
          background: `radial-gradient(ellipse at 50% 30%, rgba(227,66,92,0.05) 0%, transparent 60%), white`,
        }}>
          <img src="/gift-icon-v2.png" alt="GGR" style={{ height: '72px', marginBottom: '24px' }} />

          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '8px',
            padding: '8px 20px', borderRadius: '50px',
            background: '#10B98115', border: '1px solid #10B98125', marginBottom: '24px',
          }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#10B981' }} />
            <span style={{ fontSize: '12px', color: '#10B981', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase' }}>Live Platform • Ready to Scale</span>
          </div>

          <h2 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '44px', fontWeight: 700, color: C.charcoal, lineHeight: 1.15, marginBottom: '16px', maxWidth: '700px',
          }}>
            The platform is <span style={{ color: C.coral }}>built</span>, <span style={{ color: C.gold }}>tested</span>, and <span style={{ color: '#10B981' }}>ready to launch.</span>
          </h2>

          <p style={{ fontSize: '16px', color: '#888', maxWidth: '550px', lineHeight: 1.7, marginBottom: '36px' }}>
            Grand Gather Registry is not an idea on paper — it's a fully functional, live platform with 20+ features, an AI assistant in 7 languages, and a founding vendor partner already committed.
          </p>

          {/* Year targets */}
          <div style={{ display: 'flex', gap: '24px', marginBottom: '40px', flexWrap: 'wrap', justifyContent: 'center' }}>
            {[
              { year: 'Year 1', targets: ['500+ vendors onboarded', '1,000+ event hosts', '5,000+ bookings facilitated', '5 direct jobs created'] },
              { year: 'Year 2', targets: ['2,000+ vendors', '5 provinces covered', 'Mobile app launch', '15 direct jobs'] },
              { year: 'Year 3', targets: ['5,000+ vendors nationally', 'All 9 provinces', 'Payment gateway live', '20+ direct jobs'] },
            ].map((y, i) => (
              <div key={i} style={{
                padding: '20px', borderRadius: '14px', textAlign: 'left',
                background: '#FAFAFA', border: '1px solid #f0f0f0', width: '220px',
              }}>
                <div style={{ fontSize: '14px', fontWeight: 800, color: C.coral, marginBottom: '10px' }}>{y.year}</div>
                {y.targets.map((t, j) => (
                  <div key={j} style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '5px' }}>
                    <div style={{ width: '5px', height: '5px', borderRadius: '50%', background: C.coral, flexShrink: 0 }} />
                    <span style={{ fontSize: '11px', color: '#555' }}>{t}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* App Store badges */}
          <div style={{ marginBottom: '32px' }}>
            <div style={{ fontSize: '11px', color: '#bbb', marginBottom: '12px', letterSpacing: '2px', textTransform: 'uppercase' }}>Coming Soon</div>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <AppStoreBadge type="apple" />
              <AppStoreBadge type="google" />
            </div>
          </div>

          {/* Recognition */}
          <div style={{
            display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '32px',
          }}>
            <div style={{ padding: '12px 20px', borderRadius: '10px', background: '#FFF7ED', border: '1px solid #FFEDD5', textAlign: 'center' }}>
              <div style={{ fontSize: '20px', marginBottom: '4px' }}>🏆</div>
              <div style={{ fontSize: '12px', fontWeight: 700, color: '#C2410C' }}>Top 3 Finalist</div>
              <div style={{ fontSize: '10px', color: '#9A3412' }}>SAFT Awards 2025</div>
            </div>
            <div style={{ padding: '12px 20px', borderRadius: '10px', background: '#EFF6FF', border: '1px solid #DBEAFE', textAlign: 'center' }}>
              <div style={{ fontSize: '20px', marginBottom: '4px' }}>🏆</div>
              <div style={{ fontSize: '12px', fontWeight: 700, color: '#1D4ED8' }}>Top 10 Finalist</div>
              <div style={{ fontSize: '10px', color: '#1E40AF' }}>FNB App of the Year 2025</div>
            </div>
          </div>

          {/* Contact */}
          <div style={{
            padding: '20px 32px', borderRadius: '14px',
            background: C.charcoal, display: 'inline-flex', flexDirection: 'column', alignItems: 'center',
          }}>
            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: '18px', color: 'white', fontWeight: 600, marginBottom: '4px' }}>Grand Gather Registry</div>
            <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.3)', marginBottom: '8px' }}>Plan. Register. Celebrate.</div>
            <div style={{ fontSize: '12px', color: C.coral, fontWeight: 600 }}>grandgatherregistry.co.za</div>
            <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.25)', marginTop: '4px' }}>info@grandgatherregistry.co.za • +27 74 882 1913</div>
            <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.15)', marginTop: '8px' }}>Ga-Rankuwa, Gauteng, South Africa</div>
          </div>
        </section>

      </div>
    </div>
  );
}
